/**
 * 관심종목 관리 API
 * OpenAPI Generator로 생성된 타입을 사용하며, 기존 Axios 인스턴스와 통합
 */
export class WatchListService {
    constructor(axiosInstance) {
        Object.defineProperty(this, "axios", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.axios = axiosInstance;
    }
    /**
     * 관심종목 목록 조회
     * 사용자의 관심종목 전체 목록을 조회한다.
     * @returns 관심종목 목록 조회 결과
     */
    getWatchList() {
        return this.axios.get(`/main/v1/watchlist`);
    }
    /**
     * 관심종목 등록
     * 새로운 관심종목을 등록한다.
     * @returns 관심종목 등록 결과
     */
    addToWatchList(request) {
        return this.axios.post(`/main/v1/watchlist`, request);
    }
    /**
     * 관심종목 삭제
     * 등록된 관심종목을 삭제한다.
     * @param stockCode - 종목 코드
     * @returns 관심종목 삭제 결과
     */
    removeFromWatchList(stockCode) {
        return this.axios.delete(`/main/v1/watchlist/${stockCode}`);
    }
}
//# sourceMappingURL=watchlist.service.js.map